<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="/dashboard/">
        <img
          class="navbar-brand-full"
          src="img/brand/comcast-arc.png"
          width="100"
          height="45"
          alt="CoreUI Logo"
          style="object-fit: cover;"
        />
        <img
          class="navbar-brand-minimized"
          src="img/brand/part.png"
          width="20"
          height="20"
          alt="Fiber Node Services"
        />
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen="true" />
      <b-navbar-nav class="d-md-down-none" style="margin-left: 0; margin-right: auto;">
        <div style="display: flex; align-items: center; flex-wrap: nowrap; margin-left: 55px; margin-bottom: 5px; margin-top: 5px;">
          <span style="line-height: 30px; margin-right: 4px;">
            Select Model:
          </span>
          <b-form-select
            v-model="selectedModel"
            :options="options"
            :disabled="modelStore.isFetching || isModelSelectDisabled"
            value-field="item"
            text-field="name"
            style="width:200px; color: white; background: #343b41;"
          />
        </div>
        <div style="display: flex; align-items: center; flex-wrap: nowrap; margin-left: 55px; margin-bottom: 5px; margin-top: 5px;">
          <span style="line-height: 30px; margin-right: 4px;">
             Node Mid Split Project:
          </span>
          <c-switch
            class="mx-1"
            color="primary"
            v-model="isSpaced"
            variant="pill"
            :checked="isSpaced"
            @change="toggleFlagChange"
          />
        </div>
        <div style="display: flex; align-items: center; flex-wrap: nowrap; margin-bottom: 5px; margin-top: 5px;">
        <b-form-input
          style="display:inline-block; width:150px;margin-left:150px"
          v-model="searchQuery"
          type="search"
          id="filterInput"
          placeholder="Type to Search"
        ></b-form-input>
        <b-form-select id="basicSelect"
                       :plain="true"
                       :options="[{text:'Serial', value:'serialNumber'}]"
                       placeholder="Please select"
                       v-model="selectedSearchType"
                       text-field="text"
                       value-field="value">
        </b-form-select>
        <b-button
          :disabled="searchQuery ? false : true"
          @click="searchFor()"
        >Search </b-button>
        </div>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <DefaultHeaderDropdownAccnt />
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav style="width: 230px" :navItems="nav"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <div style="padding-top: 17px" class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <TheFooter>
      <div></div>
      <div class="ml-auto">
        <a href="https://www.fibernode.com/main/">Fiber Node Services Inc.</a>
        <span class="ml-1">&copy; 2020</span>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import nav from "@/utils/_nav";
import {
  Aside as AppAside,
  AsideToggler,
  Breadcrumb,
  Switch as cSwitch,
  Footer as TheFooter,
  Header as AppHeader,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  SidebarToggler
} from "@coreui/vue";
import axi from "axios";
import DefaultAside from "./DefaultAside";
import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";
import { modelStore, setSelectedModel, toggleFlagChange } from '@/stores/modelStore';

export default {
  name: "DefaultContainer",
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    cSwitch,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data() {
    return {
      nav: nav.items,
      full_name: "",
      ip: "",
      options: [
        { item: 'All', name: 'All' },
        { item: 'Fiber Gear', name: 'Fiber Gear' },
        { item: 'Line Gear', name: 'Line Gear' },
      ],
      selectedSearchType: "serialNumber",
      searchQuery: null,
    };
  },
  methods: {
    searchFor() {
      const { type, value } = this.$route.query;
      if (type !== this.selectedSearchType  || value !== this.searchQuery) {
        this.$router.push('/search/?type=' + this.selectedSearchType + '&value=' + this.searchQuery);
      }
    },
    getUserData() {
      axi.get("https://www.cloudflare.com/cdn-cgi/trace").then(res => {
        const ipRegex = /[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}/;
        const IP = res.data.match(ipRegex)[0];
        this.ip = IP;
        this.logData();
      });
    },
    logData() {
      let formData = new FormData();
      formData.append("portal", "comcast_arc");
      formData.append("ip", this.ip);
      formData.append("user", localStorage.getItem("arr_user"));
      this.$http
        .post("api/logUser.php", formData)
        .then()
        .catch(err => {
          console.log(err);
        });
    },
    toggleFlagChange,
  },
  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        route => route.name || route.meta.label
      );
    },
    modelStore() {
      return modelStore;
    },
    selectedModel: {
      get() {
        return modelStore.selectedModel;
      },
      set(val) {
        setSelectedModel(val);
      },
    },
    isModelSelectDisabled() {
      return this.$route.path.startsWith("/model/");
    },
    isSpaced: {
     get() {
        return modelStore.isSpaced;
      },
      set(val) {
        toggleFlagChange(val);
      },
    },
  },
  mounted() {
    this.full_name = localStorage.getItem("arr_full_name");
  },
  created() {
    this.getUserData();
  }
};
</script>

<style>
.sidebar .nav {
  width: 225px;
}
html:not([dir="rtl"]) .sidebar {
  margin-left: -225px;
}
@media (min-width: 992px) {
  .sidebar-minimized .sidebar .sidebar-nav {
    overflow: visible;
    width: 50px !important;
  }
}
</style>
